import { useEffect, useState } from 'react';

export const useSessionStartedAt = (isAuthenticated: boolean): number | null => {
  const [startedAt, setStartedAt] = useState<number | null>(null);

  useEffect(() => {
    setStartedAt((previous) => {
      if (!isAuthenticated) return null;
      return previous ?? Date.now();
    });
  }, [isAuthenticated]);

  return startedAt;
};

export const isFreshForSession = (
  updatedAt: number | undefined,
  sessionStartedAt: number | null,
): boolean => sessionStartedAt !== null && updatedAt != null && updatedAt >= sessionStartedAt;
